module.exports = function getResource (label, vars = []) {
    const resources = {
        confirmBasketUpdateModalTitle: 'Confirmation',
        confirmBasketUpdateModalButtonText: 'Continue',
        sureToContinueMessage: 'Are you sure you want to continue?',
        error: 'Error',
        ok: 'OK'
    };
    return resources[label];
};
